function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define("YWWriterIconsReact.CloseL", ["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.React);
    global.YWWriterIconsReact = global.YWWriterIconsReact || {};
    global.YWWriterIconsReact["CloseL"] = mod.exports.default;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (exports, React) {
  "use strict";

  var CloseL = props => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CloseL-__clip0_67_4549)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92891 3.51472C4.53838 3.1242 3.90522 3.1242 3.51469 3.51472C3.12417 3.90525 3.12417 4.53841 3.51469 4.92894L10.5858 12L3.51472 19.0711C3.1242 19.4616 3.1242 20.0948 3.51472 20.4853C3.90525 20.8758 4.53841 20.8758 4.92894 20.4853L12 13.4142L19.071 20.4853C19.4616 20.8758 20.0947 20.8758 20.4853 20.4853C20.8758 20.0948 20.8758 19.4616 20.4853 19.0711L13.4142 12L20.4853 4.92896C20.8758 4.53843 20.8758 3.90527 20.4853 3.51474C20.0948 3.12422 19.4616 3.12422 19.0711 3.51474L12 10.5858L4.92891 3.51472Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CloseL-__clip0_67_4549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  }))));
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = CloseL;
});